
import { Badge } from "@/components/ui/badge";
import { ShieldAlert } from "lucide-react";

export function AdminBadge() {
  return (
    <Badge variant="secondary" className="ml-2 gap-1">
      <ShieldAlert className="h-3 w-3" />
      Admin
    </Badge>
  );
}
